import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchAttendanceRequest } from "../../../api/attendance";
import { getFullName } from '../../../helpers/functions/employee';
import moment from "moment";

class AttendanceDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                employee: null,
                date: { type: Date, default: null },
                timeIn: null,
                breakAmStart: null,
                breakAmEnd: null,
                lunchStart: null,
                lunchEnd: null,
                breakPmStart: null,
                breakPmEnd: null,
                timeOut: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchAttendance(instanceId)
        }
    }

    fetchAttendance = (id) => {
        fetchAttendanceRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            employee,
            date,
            timeIn,
            breakAmStart,
            breakAmEnd,
            lunchStart,
            lunchEnd,
            breakPmStart,
            breakPmEnd,
            timeOut,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Attendance Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goBack()}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employee</p>
                            {employee ? getFullName(employee) : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Date</p>
                            {date ? moment.utc(date).format('MMMM Do YYYY') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Time In</p>
                            {timeIn || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Break Am Start</p>
                            {breakAmStart || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Break Am End</p>
                            {breakAmEnd || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Lunch Start</p>
                            {lunchStart || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Lunch End</p>
                            {lunchEnd || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Break Pm Start</p>
                            {breakPmStart || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Break Pm End</p>
                            {breakPmEnd || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Time Out</p>
                            {timeOut || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('attendance', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default AttendanceDetails;
